<template>
  <div class="body">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Bai+Jamjuree:wght@400;600&display=swap" rel="stylesheet">
    <Header />
    <Hero />
    <Cloud />
    <Anywhere />
    <Workflow />
    <Logos />
    <Download />
    <Footer />
  </div>
</template>

<script>
import Header from '../components/clipboard/Header.vue';
import Hero from '../components/clipboard/Hero.vue';
import Cloud from '../components/clipboard/Cloud.vue';
import Anywhere from '../components/clipboard/Anywhere.vue';
import Workflow from '../components/clipboard/Workflow.vue';
import Logos from '../components/clipboard/Logos.vue';
import Download from '../components/clipboard/Download.vue';
import Footer from '../components/clipboard/Footer.vue';

export default {
  name: 'Clipboard',
  components: {
    Hero,
    Header,
    Cloud,
    Anywhere,
    Workflow,
    Logos,
    Download,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
// $breakpoints
$desktop-media-1: 75em;

.body {
  --strong-dark-cyan: hsl(171, 40%, 44%);
  --strong-cyan: hsl(171, 66%, 44%);
  --light-blue: hsl(233, 100%, 69%);
  --light-dark-blue: hsl(233, 50%, 50%);
  --dark-grayish-blue: hsl(210, 10%, 33%);
  --light-grayish-blue: hsl(220, 18%, 97%);
  --grayish-blue: hsl(201, 11%, 66%);
  --white: hsl(0, 100%, 100%);

  --border-radius: 0.5rem;
  /* spacing */
  --sm-spacer: 2rem;
  --bg-spacer: 4rem;

  /* fonts */
  --fs-h1: 2rem;
  --fs-h2: 1.5rem;
  --fs-h3: 1.25rem;
  --fs-base: 1rem;
  --fw-normal: 400;
  --fw-bold: 600;
  --ff-default: 'Bai Jamjuree', sans-serif;

  --text-width: 55ch;

  font-family: var(--ff-default);
  font-size: var(--fs-base);
  text-align: center;
  min-height: 100vh;
  color: var(--dark-grayish-blue);
  @media (min-width: $desktop-media-1) {
    --fs-h1: 3rem;
    --fs-h2: 2rem;
    --fs-h3: 1.5rem;
    --fs-base: 1.25rem;

    /* spacing */
    --sm-spacer: 3rem;
    --bg-spacer: 6rem;
  }
}

</style>
